import React from 'react'
import './IconStyles.css';
import { MdOutlineTrackChanges } from "react-icons/md";

export const GoalSetsIcon = (props) => (
  <div style={{ minWidth: "1.75em" }}>
    <MdOutlineTrackChanges
      size={props.size ? props.size : "1.25em"}
      color={props.color ? props.color : undefined}
    />
  </div>
)
